<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()

useHead({
	meta: [
		{
			name: 'version',
			content: runtimeConfig.public.clientVersion,
		},
		{
			property: 'og:site_name',
			content: 'Health Nutrition',
		},
		{
			property: 'og:locale',
			content: 'en_US',
		},
	],
})
</script>

<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
</template>
